import { Row, Text } from '~/commonComponents';
import StarIcon from '~/images/icons/StarIcon';

interface IProfessionalRatingProps {
  rating?: number;
}

export const ProfessionalRating = ({ rating }: IProfessionalRatingProps) => {
  if (rating == null) {
    return null;
  }

  return (
    <Row alignItems="center" justifyContent="center" gap={2}>
      <div style={{ marginTop: 5 }}>
        <StarIcon width={20} height={20} />
      </div>
      <Text bold fontSize={20}>
        {rating?.toFixed(1)}
      </Text>
    </Row>
  );
};
